const E = 30;
export {
  E as CAPITAL_REPAYMENT_FREQUENCY
};
